import React from 'react';

import PixelSetsSelect from './PixelSetsSelect';

const PixelSetsSelectAdapter = ({input, showEmptyMsg})=>{
  return <PixelSetsSelect selectedIds={input.value} onChange={input.onChange} showEmptyMsg={showEmptyMsg} />
}

export default PixelSetsSelectAdapter;


// WEBPACK FOOTER //
// ./src/components/PixelSets/PixelSetsSelectAdapter.js